import React from 'react';
import { Login } from '../../components';

const AdminAccess: React.FC = () => {
  return <Login />;
};

export default AdminAccess;
